export default __webpack_public_path__ + "1c13b8c8d718d190db7d963eddf810b7.png";